import React from "react";
import {NavLink} from "react-router-dom";

const CardDetails = ({item, className}) => {

    return (
        <div className={className}>
            {item.stats.map((data, index) => {
                return (
                    <div className="flex items-center gap-x-1" key={index}>
                        <i className={`icon-${data.icon} text-xs`}></i>
                        <span>{data.label}</span>
                    </div>
                )
            })}
            <NavLink to="/" className="flex items-center gap-x-1 text-pink-400">
                <span className="uppercase">{item.linkLabel}</span>
                <i className={`icon-${item.linkIcon} text-s`}></i>
            </NavLink>
        </div>
    )
}

export default CardDetails;